import moment from 'moment';

export const formatDate = (date, format = 'MMMM D, YYYY') =>
  date ? moment(date).format(format) : date;

export const formatDateTime = (date, format = 'MMMM D, YYYY, h:mm A') =>
  date ? moment(date).format(format) : date;

export const formatDateTimeOnlyWithSeconds = (date, format = 'h:mm:ss A') =>
  date ? moment(date).format(format) : date;

export const formatDateTimeForAPI = (date) =>
  date ? moment(date).utc().format() : date;

export const formatDateTimeConversational = (date) =>
  date ? moment(date).fromNow() : date;

export const formatVersionDate = (d) => {
  const yyyy = d.getFullYear().toString();
  let mm = (d.getMonth() + 1).toString();
  let dd = d.getDate().toString();
  let hh = d.getHours().toString();
  let mi = d.getMinutes().toString();
  let ss = d.getSeconds().toString();

  mm = mm.length === 1 ? '0' + mm : mm;
  dd = dd.length === 1 ? '0' + dd : dd;
  hh = hh.length === 1 ? '0' + hh : hh;
  mi = mi.length === 1 ? '0' + mi : mi;
  ss = ss.length === 1 ? '0' + ss : ss;

  return yyyy + mm + dd + hh + mi + ss;
};
